import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError, ErrorMessage } from "@shared/types";
import { Subscription } from "@modules/subscriptions/types";
import { SubscriptionFormValues } from "@modules/subscriptions/validations";

import { createSubscriptionService } from "./service";
import { UseCreateSubscriptionMutationOptions } from "./types";

export function useCreateSubscriptionMutation(
  options?: UseCreateSubscriptionMutationOptions
) {
  const { open } = useNotification();

  return useMutation<Subscription[], ApiError, SubscriptionFormValues>({
    mutationFn: createSubscriptionService,
    onError: (error: ApiError | ErrorMessage) => {
      open?.({
        type: "error",
        message:  "response" in error
          ? error.response?.data?.error
          : error.message,
      });
    },
    ...options,
  });
}
